module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_arrow_down-8f5c577dad883e7300b27f27212c1230.svg";